import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  INTERACTIVE_ANALYTICS_CONTEXT_GAP,
  APACHE_OSSIE_HUB,
} from '../../../../content/enterpriseMessaging';
import ContextGapCrossfade from './ContextGapCrossfade';
import { PBISection } from './PBIContent';

export default function ContextGapFoundation() {
  const copy = INTERACTIVE_ANALYTICS_CONTEXT_GAP;
  const hub = APACHE_OSSIE_HUB;

  return (
    <PBISection accent="semantic" id="semantic-foundation" tight>
      <div className="grid min-w-0 grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-x-16 lg:gap-y-10 lg:items-center">
        <div className="min-w-0 lg:order-1 lg:pr-4">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">{copy.title}</h2>
          <p className="mt-4 text-base leading-relaxed text-ink-600">{copy.body}</p>
          <ul className="mt-6 space-y-3">
            {copy.points.map((point) => (
              <li key={point.title} className="border-l-2 border-l-brand-500 pl-4">
                <p className="text-sm font-semibold text-ink-900">{point.title}</p>
                <p className="mt-1 text-sm text-ink-600 leading-relaxed">{point.body}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:order-2 flex w-full min-w-0 flex-col gap-6 lg:max-w-none">
          <ContextGapCrossfade />
          <div className="min-w-0 rounded-2xl border border-brand-100/80 bg-gradient-to-br from-brand-50/40 to-[#f8fcff] p-5 sm:p-6 shadow-sm ring-1 ring-ink-100/60">
            <p className="eyebrow text-brand-700">{hub.eyebrow}</p>
            <p className="mt-2 text-sm leading-relaxed text-ink-600">{hub.body}</p>
            <div className="mt-4 flex min-w-0 flex-wrap gap-x-3 gap-y-2">
              <a
                href={hub.primaryCta.href}
                target="_blank"
                rel="noreferrer"
                className="inline-flex min-h-[24px] items-center gap-1.5 text-sm font-semibold text-brand-600 hover:text-brand-700"
              >
                {hub.primaryCta.label}
                <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
              <a
                href={hub.docsCta.href}
                target="_blank"
                rel="noreferrer"
                className="inline-flex min-h-[24px] items-center gap-1.5 text-sm font-medium text-ink-600 hover:text-brand-600"
              >
                {hub.docsCta.label}
                <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
              <a href={hub.secondaryCta.href} className="inline-flex min-h-[24px] items-center text-sm font-medium text-ink-600 hover:text-brand-600">
                {hub.secondaryCta.label} →
              </a>
            </div>
          </div>
        </div>
      </div>
    </PBISection>
  );
}
